export enum GitRepositoryOwnerType {
  USER = 'user',
  ORGANIZATION = 'organization',
}
